// Centralized Team Data Model for Halo Aesthetic Clinic (E-E-A-T Medical Authority)
import lydiaImg from '../assets/images/employees/lydia.jpg';
import nikkiImg from '../assets/images/employees/nikki.jpg';
import junieImg from '../assets/images/employees/junie.jpg';
import michelImg from '../assets/images/employees/michel.jpg';
import monicaImg from '../assets/images/employees/monica.jpg';
import healyImg from '../assets/images/employees/healy.jpg';
import allyImg from '../assets/images/employees/ally.jpg';
import kathyImg from '../assets/images/doctor6.jpg';

// Lydia Certificates
import lydiaCertMdCodes from '../assets/images/halo_employee_certificate/lydia/certificate MDcodes L.png';
import lydiaCertInjection from '../assets/images/halo_employee_certificate/lydia/injection certificate.png';
import lydiaCertLaser from '../assets/images/halo_employee_certificate/lydia/Certificatelaser.png';

// Healy Certificates
import healyCertThermage from '../assets/images/halo_employee_certificate/healy/certificate thermage.png';
import healyCertSynosure from '../assets/images/halo_employee_certificate/healy/certificate of synosure.png';
import healyCertLaser from '../assets/images/halo_employee_certificate/healy/Certificate laser.png';
import healyCertXcite from '../assets/images/halo_employee_certificate/healy/xcite certificate.png';

// Junie Certificates
import junieCertThermage from '../assets/images/halo_employee_certificate/junie/Image_20261004135942_17_8.jpg';
import junieCertCynosure from '../assets/images/halo_employee_certificate/junie/Image_20261004133747_2_8.jpg';
import junieCertPhlebotomy from '../assets/images/halo_employee_certificate/junie/Image_20261004135430_15_8.jpg';
import junieCertUltherapy from '../assets/images/halo_employee_certificate/junie/Image_20261004133746_1_8.jpg';

// Monica Certificates
import monicaCertBelkyra from '../assets/images/halo_employee_certificate/monica/belkyra.png';
import monicaCertLaser from '../assets/images/halo_employee_certificate/monica/laser.jpg';
import monicaCertSkin from '../assets/images/halo_employee_certificate/monica/skin.jpg';
import monicaCertThermage from '../assets/images/halo_employee_certificate/monica/thermage.png';

export const teamMembers = [
  {
    id: 1,
    slug: 'lydia',
    hasDetailPage: true,
    name: {
      en: 'Lydia',
      cn: 'Lydia'
    },
    title: {
      en: 'Chief Nurse Manager & Lead Injector',
      cn: '首席护士长 & 资深微整注射专家'
    },
    role: {
      en: 'Registered Practical Nurse (CNO Certified)',
      cn: 'CNO 执牌注册执业护士'
    },
    isLicensedMedical: true,
    licenseNumber: '',
    avatar: lydiaImg,
    experienceYears: '8+',
    clientsTreated: '5,000+',
    verifiedBadge: 'AMI MD Codes™ Certified',
    keyCredentials: {
      en: ['CNO Registered Practical Nurse License', 'AMI MD Codes™ Distinction Injector', 'CAMA Advanced Facial Injection Certified', 'Cynosure Medical Laser Specialist'],
      cn: ['CNO 安大略省注册执业护士执照', 'Allergan AMI MD Codes™ 权威注射认证', 'CAMA 加拿大医美协会高级注射认证', 'Cynosure 医疗级光电仪器认证医师']
    },
    bio: {
      en: 'Lydia is widely admired for her clinical precision and artistic expertise, boasting over 8 years of specialized experience in facial aesthetic injections and energy device treatments. She possesses deep expertise in facial anatomy and precision injection techniques, blending medical safety with natural aesthetic harmony. Committed to international clinical excellence, Lydia regularly participates in top-tier global symposiums such as IMCAS in Paris to master cutting-edge biostimulator and filler techniques. Known for her gentle hand and meticulous consultations, she customizes every treatment plan to accentuate individual facial structures seamlessly.',
      cn: 'Lydia 拥有8年以上高级医美注射与光电临床经验，以精湛的解剖学功底、极高的医疗安全标准和自然优雅的美学理念在多伦多医美界享有盛誉。她专注于高级面部 MD Codes™ 定点注射、童颜针（PLLA）与胶原再生修复，将临床医学的严谨与精细微雕相融合。Lydia 定期赴巴黎 IMCAS 等国际顶尖医美学术峰会交流进修，保持技术与美学前沿同步。她深谙东方面部骨骼特色，提倡“修饰瑕疵、保留个性”的自然抗衰哲学，深受数千名客户信赖。'
    },
    philosophy: {
      en: 'Aesthetic medicine is the sacred intersection of precise anatomical science and subtle artistic elegance. My goal is not to change who you are, but to restore your youthful vitality and enhance your natural contours with absolute safety.',
      cn: '医美注射不仅是医学操作，更是严谨解剖学与细腻艺术美的交融。我的目标绝不是改变你的面貌，而是在绝对安全的前提下，通过精准微调还原肌肤的年轻态与生机活力。'
    },
    specialties: {
      en: ['MD Codes™ Facial Contouring', 'Sculptra & Radiesse Biostimulators', 'Hyaluronic Acid Dermal Fillers', 'Botox / Dysport Neuromodulators', 'PicoSure® Pro & Medical Lasers', 'Mesotherapy Skin Boosters'],
      cn: ['MD Codes™ 骨骼精准微雕', 'Sculptra 童颜针与微晶瓷胶原再生', '玻尿酸面部精细填充', '除皱瘦脸肉毒素注射', 'PicoSure® Pro 蜂巢皮秒祛斑', '水光针与中胚层微针复配']
    },
    specialtySlugs: ['sculptra', 'radiesse', 'dermal-fillers', 'botox', 'picosure-pro', 'mesotherapy'],
    certificates: [
      {
        id: 'lydia-mdcodes',
        title: {
          en: 'AMI MD Codes™ Distinction Certificate',
          cn: 'Allergan AMI MD Codes™ 面部精细注射权威认证'
        },
        issuer: 'Allergan Medical Institute (AMI)',
        image: lydiaCertMdCodes,
        category: 'Injection'
      },
      {
        id: 'lydia-injection',
        title: {
          en: 'Advanced Aesthetic Injectable Certification',
          cn: 'CAMA 加拿大医美协会高级注射与面部解剖认证'
        },
        issuer: 'Canadian Association of Medical Aesthetics',
        image: lydiaCertInjection,
        category: 'Injection'
      },
      {
        id: 'lydia-laser',
        title: {
          en: 'Medical Laser Operator & Energy Device Certificate',
          cn: 'Cynosure 医疗激光与光电设备操作医师认证'
        },
        issuer: 'Cynosure Laser Academy',
        image: lydiaCertLaser,
        category: 'Laser'
      }
    ]
  },
  {
    id: 2,
    slug: 'nikki',
    hasDetailPage: false,
    name: {
      en: 'Nikki',
      cn: 'Nikki'
    },
    title: {
      en: 'Co-Founder',
      cn: '联合创始人'
    },
    role: {
      en: 'Co-Founder',
      cn: '联合创始人'
    },
    licenseNumber: '',
    avatar: nikkiImg,
    bio: {
      en: 'Nikki is the heart of Halo. With extensive experience across multiple business sectors in Shanghai, she brings both sharp commercial acumen and in-depth knowledge of aesthetic clinic management. She firmly believes that outstanding service and client satisfaction are the cornerstones of the brand. Her professionalism, respect for individuality, and devotion to beauty form the very foundation of Halo’s culture of trust and uniqueness.',
      cn: 'Nikki是Halo的灵魂人物，在上海深耕多个商业领域，积累了丰富经验。她将敏锐的商业洞察与医美管理知识完美结合，坚信卓越的服务与客户满意是品牌的核心。她的专业精神以及对美的执着追求，奠定了Halo信任与独特性的基石。'
    },
    specialties: {
      en: ['Clinic Leadership', 'Client Care Excellence', 'Aesthetic Management'],
      cn: ['诊所管理', '客户关怀', '医美服务体系']
    },
    certificates: []
  },
  {
    id: 3,
    slug: 'junie',
    hasDetailPage: true,
    name: {
      en: 'Junie',
      cn: 'Junie'
    },
    title: {
      en: 'Founder / Clinic Director / Skin Specialist',
      cn: '创始人 / 诊所总监 / 皮肤管理专家'
    },
    role: {
      en: 'Founder / Clinic Director / Skin Specialist',
      cn: '创始人 / 诊所总监 / 皮肤管理专家'
    },
    licenseNumber: '',
    avatar: junieImg,
    experienceYears: '8+',
    clientsTreated: '4,000+',
    verifiedBadge: 'Top Sales & Thermage® Certified',
    keyCredentials: {
      en: [
        'Top 1 consultant performance at previous company',
        'Solta Thermage® FLX Certified Clinical Operator',
        'Merz Aesthetics Ultherapy® Clinical Certified',
        'Cynosure Medical Laser System Specialist',
        'Canadian Ultrasound Institute Phlebotomy & Venipuncture Certified'
      ],
      cn: [
        '前机构 Top 1 咨询业绩',
        'Solta Thermage® 第五代热玛吉官方认证专家',
        'Merz Aesthetics Ultherapy® 美版超声刀认证专家',
        'Cynosure 医疗级激光系统临床认证',
        'Canadian Ultrasound Institute 静脉穿刺与抽血临床认证'
      ]
    },
    bio: {
      en: 'Junie is a highly respected leader in the medical aesthetics field. With a background in regenerative medicine, she has worked alongside leading international doctors, coordinating complex treatment plans to ensure the highest quality of care. Since 2018, she has been recognized as a Senior Aesthetic Consultant, renowned for designing tailored, results-driven solutions.',
      cn: 'Junie曾在再生医学领域与全球顶尖医生合作，统筹复杂治疗方案，确保服务品质。自2018年起，她以资深美学顾问的身份，为客户量身定制效果显著的方案。她熟悉最新的护肤产品与技术，擅长打造个性化治疗计划。'
    },
    philosophy: {
      en: 'True beauty lies in personalized, scientifically backed care. My passion is crafting combination treatment plans that enhance your natural skin health and confidence.',
      cn: '真正的美的源泉在于个性化与科学严谨的护肤方案。我致力于结合前沿光电与顶级护肤疗程，帮助每位客户提升肌肤健康与自信光采。'
    },
    specialties: {
      en: ['Custom Combination Treatment Protocols', 'Thermage® FLX Tightening', 'Ultherapy® Non-Invasive Lifting', 'Skin Analysis & Skincare Technologies', 'Laser & Energy Device Rejuvenation'],
      cn: ['个性化联合治疗方案', 'Thermage® FLX 热玛吉紧致', 'Ultherapy® 超声刀无创提升', '精密皮肤检测与分层管理', '光电抗衰与肌肤焕新']
    },
    specialtySlugs: ['thermage-flx', 'ultherapy', 'picosure-pro', 'bbl-hero'],
    certificates: [
      {
        id: 'junie-thermage',
        title: {
          en: 'Thermage® Certified Clinical Operator',
          cn: 'Solta Thermage® 热玛吉官方认证证书'
        },
        issuer: 'Solta Medical',
        image: junieCertThermage,
        category: 'Radiofrequency'
      },
      {
        id: 'junie-ultherapy',
        title: {
          en: 'Ultherapy® Certificate of Completion',
          cn: 'Merz Aesthetics Ultherapy® 美版超声刀官方认证'
        },
        issuer: 'Merz Aesthetics',
        image: junieCertUltherapy,
        category: 'Ultrasound'
      },
      {
        id: 'junie-cynosure',
        title: {
          en: 'Cynosure Hands-On Laser Training Certificate',
          cn: 'Cynosure 医疗激光系统实操培训认证'
        },
        issuer: 'Cynosure',
        image: junieCertCynosure,
        category: 'Laser'
      },
      {
        id: 'junie-phlebotomy',
        title: {
          en: 'Phlebotomy & Venipuncture Certificate of Completion',
          cn: '加拿大超声学院静脉穿刺与抽血专业认证'
        },
        issuer: 'Canadian Ultrasound Institute',
        image: junieCertPhlebotomy,
        category: 'Clinical'
      }
    ]
  },
  {
    id: 4,
    slug: 'michel',
    hasDetailPage: false,
    name: {
      en: 'Michel',
      cn: 'Michel'
    },
    title: {
      en: 'Registered Nurse (RN)',
      cn: '注册护士 (RN)'
    },
    role: {
      en: 'Registered Nurse',
      cn: '注册护士'
    },
    isLicensedMedical: true,
    licenseNumber: '',
    avatar: michelImg,
    bio: {
      en: 'Michel brings a distinctive dual background in medicine and nursing to his aesthetic practice, reflecting a comprehensive understanding of both the science and art of aesthetics. Thorough and precise in his approach, he places strong emphasis on detailed risk assessment to ensure every procedure is performed with the utmost safety.',
      cn: 'Michel将医学与护理学的背景融入医美，展现了对科学与艺术的深刻理解。他一丝不苟，注重风险评估，确保治疗安全精准。同时，他以贴心沟通和个性化护理为客户带来安心与信心的体验。'
    },
    specialties: {
      en: ['Clinical Risk Assessment', 'Injectable Safety', 'Patient Consultation'],
      cn: ['临床风险评估', '注射安全规范', '术前专业咨询']
    },
    certificates: []
  },
  {
    id: 5,
    slug: 'monica',
    hasDetailPage: true,
    name: {
      en: 'Monica',
      cn: 'Monica'
    },
    title: {
      en: 'Registered Nurse (RN) & Senior Aesthetic Nurse',
      cn: '注册护士 (RN) & 资深医美护士'
    },
    role: {
      en: 'Operating Room & Aesthetic RN',
      cn: '手术室级注册护士'
    },
    isLicensedMedical: true,
    licenseNumber: '',
    avatar: monicaImg,
    experienceYears: '13+',
    clientsTreated: '5,000+',
    verifiedBadge: 'BELKYRA® & Thermage® Certified RN',
    keyCredentials: {
      en: [
        'CNO Registered Nurse License (RN)',
        '10 Years Operating Room Core Surgical Nurse Experience in Toronto',
        'AMI BELKYRA® Submental Fat Contouring Certified',
        'Solta Thermage® Certified Clinical Operator',
        'Cynosure Lutronic Laser Light Science & Skin Anatomy Specialist'
      ],
      cn: [
        'CNO 安大略省注册护士执照 (RN)',
        '10年多伦多知名医院手术室核心护理经验',
        'Allergan AMI BELKYRA® 双下巴溶脂精雕认证',
        'Solta Thermage® 热玛吉官方认证操作医师',
        'Cynosure Lutronic 激光安全与皮肤解剖学权威认证'
      ]
    },
    bio: {
      en: 'With 13 years of clinical nursing experience, including 10 years as a core surgical nurse at a renowned hospital in Toronto, Monica seamlessly blends Toronto’s strict surgical aseptic standards with refined aesthetic nursing care. She is highly experienced in surgical coordination, emergency protocols, BELKYRA® submental contouring, Thermage® skin tightening, and full-cycle post-operative skin management.',
      cn: 'Monica从事临床护理工作13年，其中10年于多伦多知名医院手术室担任核心护理骨干。将北美严格的外科无菌标准与医美精细化护理完美融合。熟练把控从注射前精准核对到消肿与恢复期皮肤养护的每一个细节，精通 BELKYRA® 双下巴溶脂精雕、Thermage® 热玛吉紧致及光电安全疗程。'
    },
    philosophy: {
      en: 'Surgical precision, strict sterile standards, and personalized care are the foundations of safety and beauty. I am dedicated to making every client feel secure and glowing.',
      cn: '外科级精密标准、无菌规范与贴心护理是医美安全与美感的基础。我致力于为每一位客户打造全方位的安全护理体验，呈现健康自然的亮丽状态。'
    },
    specialties: {
      en: ['BELKYRA® Submental Contouring', 'Thermage® FLX Tightening', 'Surgical Asepsis & Safety Protocols', 'Laser Light Science & Skin Anatomy', 'Full-Cycle Post-Op Recovery'],
      cn: ['BELKYRA® 溶脂精雕', 'Thermage® FLX 热玛吉紧致', '外科级无菌与安全规范', '光电安全与皮肤解剖管理', '术后全周期恢复与养护']
    },
    specialtySlugs: ['thermage-flx', 'belkyra-double-chin', 'picosure-pro', 'bbl-hero'],
    certificates: [
      {
        id: 'monica-belkyra',
        title: {
          en: 'BELKYRA® Injection Training Certificate',
          cn: 'Allergan AMI BELKYRA® 双下巴溶脂注射权威认证'
        },
        issuer: 'Allergan Medical Institute',
        image: monicaCertBelkyra,
        category: 'Injection'
      },
      {
        id: 'monica-thermage',
        title: {
          en: 'Thermage® Certificate of Attendance',
          cn: 'Solta Thermage® 热玛吉官方认证证书'
        },
        issuer: 'Solta Medical',
        image: monicaCertThermage,
        category: 'Radiofrequency'
      },
      {
        id: 'monica-laser',
        title: {
          en: 'Laser Light Science & Safety Certificate',
          cn: 'Cynosure Lutronic 激光安全与科学权威认证'
        },
        issuer: 'Cynosure Lutronic',
        image: monicaCertLaser,
        category: 'Laser'
      },
      {
        id: 'monica-skin',
        title: {
          en: 'Understanding Skin Anatomy Certificate',
          cn: 'Cynosure Lutronic 皮肤解剖学专业认证'
        },
        issuer: 'Cynosure Lutronic',
        image: monicaCertSkin,
        category: 'Anatomy'
      }
    ]
  },
  {
    id: 6,
    slug: 'healy',
    hasDetailPage: true,
    name: {
      en: 'Healy',
      cn: 'Healy'
    },
    title: {
      en: 'Lead Aesthetic Practitioner & Laser Master',
      cn: '资深美学医师 & 顶尖光电专家'
    },
    role: {
      en: 'Senior Laser & Energy Device Specialist',
      cn: '资深光电抗衰技术总监'
    },
    licenseNumber: '',
    avatar: healyImg,
    experienceYears: '7+',
    clientsTreated: '5,000+',
    verifiedBadge: 'Thermage® & Sciton Master Certified',
    keyCredentials: {
      en: ['Thermage® FLX Official Certified Specialist', 'Cynosure PicoSure® Pro Master Laser Operator', 'Sciton BBL HERO Clinical Distinction Specialist', 'International Laser Aesthetic Academy Certified'],
      cn: ['Thermage® FLX 第五代热玛吉官方认证专家', 'Cynosure PicoSure® Pro 蜂巢皮秒大师认证', 'Sciton BBL HERO 宽普光抗衰授权专家', '国际光电美学协会高级认证医师']
    },
    bio: {
      en: 'Healy is a recognized master in non-invasive skin rejuvenation and advanced laser therapy, bringing over 7 years of specialized medical aesthetic experience. Having trained extensively under leading international dermatology protocols, she has operated over 40 types of state-of-the-art energy-based medical devices and successfully performed personalized treatments for over 5,000 clients. Healy specializes in customizing multi-modality energy therapies—such as combining Thermage® FLX, Sciton BBL HERO, and PicoSure® Pro—to target deep skin laxity, stubborn pigmentation, and collagen degradation with extreme precision.',
      cn: 'Healy 拥有 7 年以上高级医美光电临床操作经验，是无创皮肤抗衰与精密激光领域的权威专家。曾服务于多家顶级医美连锁机构，精通操作 40 余种前沿医疗光电设备，并已成功为超过 5,000 位客户量身定制皮肤抗衰与焕肤方案。Healy 擅长联合治疗（如 Thermage® FLX 热玛吉 + Sciton BBL HERO + PicoSure® Pro 蜂巢皮秒），针对色素沉着、面部松弛及胶原流失进行多维度分层抗衰。她以专业细致的能量调控与温馨贴心的面诊沟通著称。'
    },
    philosophy: {
      en: 'Precision light and thermal energy technology allows us to rebuild skin collagen from within, achieving transformative rejuvenation without surgical downtime.',
      cn: '精密光电与热能技术赋予我们从底层重建胶原蛋白的力量。通过科学调控能量，我们在完全无创的前提下，为每一位客户呈现由内而外健康紧致的耀白肌肤。'
    },
    specialties: {
      en: ['Thermage® FLX Skin Tightening', 'PicoSure® Pro Pigmentation & Laser Rejuvenation', 'Sciton BBL HERO Photothermal Anti-Aging', 'Ultherapy® Deep Lifting', 'Potenza™ RF Microneedling', 'Customized Multi-Modality Laser Protocols'],
      cn: ['Thermage® FLX 五代热玛吉紧致祛皱', 'PicoSure® Pro 蜂巢皮秒精细祛斑与焕肤', 'Sciton BBL HERO 宽普光光子嫩肤与抗衰', 'Ultherapy® 美版超声刀深层提升', 'Potenza™ 黄金微针点阵射频', '多设备联合定制光电抗衰方案']
    },
    specialtySlugs: ['thermage-flx', 'picosure-pro', 'bbl-hero', 'ultherapy', 'potenza-rf-microneedling'],
    certificates: [
      {
        id: 'healy-thermage',
        title: {
          en: 'Thermage® FLX Certified Clinical Operator',
          cn: 'Solta Thermage® FLX 第五代热玛吉官方认证医师'
        },
        issuer: 'Solta Medical',
        image: healyCertThermage,
        category: 'Radiofrequency'
      },
      {
        id: 'healy-cynosure',
        title: {
          en: 'Cynosure PicoSure® Pro Master Laser Certificate',
          cn: 'Cynosure PicoSure® Pro 蜂巢皮秒大师认证'
        },
        issuer: 'Cynosure Laser Academy',
        image: healyCertSynosure,
        category: 'Laser'
      },
      {
        id: 'healy-xcite',
        title: {
          en: 'BBL HERO / Sciton XCITE Clinical Distinction Certificate',
          cn: 'Sciton BBL HERO 宽普光与光电抗衰官方认证'
        },
        issuer: 'Sciton Medical Systems',
        image: healyCertXcite,
        category: 'BBL / IPL'
      },
      {
        id: 'healy-laser',
        title: {
          en: 'Certified Medical Aesthetic Laser Specialist',
          cn: '持牌医美光电治疗高级专家认证证书'
        },
        issuer: 'International Laser & Aesthetic Academy',
        image: healyCertLaser,
        category: 'Laser'
      }
    ]
  },
  {
    id: 7,
    slug: 'ally',
    hasDetailPage: false,
    name: {
      en: 'Ally',
      cn: 'Ally'
    },
    title: {
      en: 'Aesthetic Practitioner',
      cn: '美学医师'
    },
    role: {
      en: 'Aesthetic Specialist',
      cn: '美学护理专家'
    },
    licenseNumber: '',
    avatar: allyImg,
    bio: {
      en: 'Ally combines strong technical expertise with a genuine passion for client care. Specializing in a wide range of treatments, she is dedicated to delivering safe, natural-looking results.',
      cn: 'Ally将专业技术与真诚热情结合，擅长多种治疗技术，致力于为客户带来安全、自然的效果。她用心倾听，细致关怀，确保每位客户都能带着焕然一新的自信离开。'
    },
    specialties: {
      en: ['Custom Skincare', 'HydraFacial & Mesotherapy', 'Client Consultation'],
      cn: ['定制皮肤管理', '海菲秀与动能素水光', '细致面诊倾听']
    },
    certificates: []
  },
  {
    id: 8,
    slug: 'kathy',
    hasDetailPage: false,
    name: {
      en: 'Kathy',
      cn: 'Kathy'
    },
    title: {
      en: 'Medical Aesthetic Practitioner & Skin Specialist',
      cn: '资深美学医师 & 皮肤管理专家'
    },
    role: {
      en: 'Aesthetic Practitioner',
      cn: '美学护理专家'
    },
    licenseNumber: '',
    avatar: kathyImg,
    bio: {
      en: 'Kathy is an experienced aesthetic practitioner specializing in advanced skin rejuvenation, microneedling therapies, and energy-based technologies. Dedicated to evidence-based skincare, she crafts tailored protocols to restore skin barrier health and enhance collagen regeneration.',
      cn: 'Kathy 拥有丰富的临床护肤与微针操作经验，专注于能量微针、皮肤屏障修复与胶原再生管理。她以严谨科学的态度与个性化方案，帮助客户实现细腻平滑的健康肤质。'
    },
    specialties: {
      en: ['Potenza™ RF Microneedling', 'Collagen Induction Therapy', 'Acne Scar Treatment'],
      cn: ['Potenza™ 黄金微针', '胶原诱导疗法', '痘坑痘印修复']
    },
    certificates: []
  }
];

export const getTeamMembers = (lang = 'en') => {
  return teamMembers.map((member) => ({
    ...member,
    hasDetailPage: !!member.hasDetailPage,
    name: member.name[lang] || member.name.en,
    title: member.title[lang] || member.title.en,
    role: member.role[lang] || member.role.en,
    licenseNumber: member.licenseNumber,
    avatar: member.avatar,
    experienceYears: member.experienceYears || '',
    clientsTreated: member.clientsTreated || '',
    verifiedBadge: member.verifiedBadge || '',
    keyCredentials: member.keyCredentials ? (member.keyCredentials[lang] || member.keyCredentials.en) : [],
    bio: member.bio[lang] || member.bio.en,
    philosophy: member.philosophy ? (member.philosophy[lang] || member.philosophy.en) : '',
    specialties: member.specialties ? (member.specialties[lang] || member.specialties.en) : [],
    specialtySlugs: member.specialtySlugs || [],
    certificates: (member.certificates || []).map(cert => ({
      ...cert,
      title: cert.title[lang] || cert.title.en
    }))
  }));
};

export const getTeamMemberBySlug = (slug, lang = 'en') => {
  if (!slug) return null;
  const lowerSlug = slug.toLowerCase().trim();
  const rawMember = teamMembers.find((m) => m.slug === lowerSlug || m.name.en.toLowerCase() === lowerSlug);
  if (!rawMember) return null;

  return {
    ...rawMember,
    hasDetailPage: !!rawMember.hasDetailPage,
    name: rawMember.name[lang] || rawMember.name.en,
    title: rawMember.title[lang] || rawMember.title.en,
    role: rawMember.role[lang] || rawMember.role.en,
    licenseNumber: rawMember.licenseNumber,
    avatar: rawMember.avatar,
    experienceYears: rawMember.experienceYears || '',
    clientsTreated: rawMember.clientsTreated || '',
    verifiedBadge: rawMember.verifiedBadge || '',
    keyCredentials: rawMember.keyCredentials ? (rawMember.keyCredentials[lang] || rawMember.keyCredentials.en) : [],
    bio: rawMember.bio[lang] || rawMember.bio.en,
    philosophy: rawMember.philosophy ? (rawMember.philosophy[lang] || rawMember.philosophy.en) : '',
    specialties: rawMember.specialties ? (rawMember.specialties[lang] || rawMember.specialties.en) : [],
    specialtySlugs: rawMember.specialtySlugs || [],
    certificates: (rawMember.certificates || []).map(cert => ({
      ...cert,
      title: cert.title[lang] || cert.title.en
    }))
  };
};
